import { render, staticRenderFns } from "./TabIdProofing.vue?vue&type=template&id=4484a453&scoped=true&"
import script from "./TabIdProofing.vue?vue&type=script&lang=js&"
export * from "./TabIdProofing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484a453",
  null
  
)

export default component.exports